import {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import queryParameters from '../../../../consts/route/queryParameters';
import {setNavigationTarget} from '../../../../state/ducks/global';
import urlUtils from '../../../../utils/urlUtils';

const useSetNavigationTarget = () => {
    const [target, deviceType] = urlUtils.getDataFromUrl(
        queryParameters.NAVIGATION_TARGET,
        queryParameters.DEVICE_TYPE
    );
    const dispatch = useDispatch();

    useEffect(() => {
        if (!target) return;

        dispatch(setNavigationTarget({target, deviceType}));
    }, [target]);
};

export default useSetNavigationTarget;
